module.exports = "1.7.3"


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxxor/version.js
 ** module id = 165
 ** module chunks = 46 47
 **/